<div>
  <p *ngIf="activeFinzyVersion === 'FINZY_V1'" class="heading">Set Investment preferences</p>
  <p *ngIf="activeFinzyVersion !== 'FINZY_V1'" class="heading"> finzyFLEX Investment Preferences <span class="small-text">(Optional)</span></p>
  <p class="secondary-text"  *ngIf="preferencesUpdated else preferencesNotYetUpdated">
    Set preferences to allocate your investments to loans and for periodical payouts from finzy
You can choose to change them below or <strong class="bold-black">skip to do this later.</strong>
  </p>
  <ng-template #preferencesNotYetUpdated>
    <p *ngIf="activeFinzyVersion === 'FINZY_V1'">Here are your selected preferences, you can choose to change them below or <strong class="bold-black">skip to do this later.</strong> For more information regarding investment preferences <a class="text-underline" [href]="getFileUrlByName('investmentPreference')" target="_blank">click here.</a></p>
    <p *ngIf="activeFinzyVersion !== 'FINZY_V1'">Here are your <string class="bold-black">finzyFLEX</string> investment preferences, you can choose to change them below or skip to do this later. For more information regarding finzyFLEX investment preferences click here. For more information regarding finzyFLEX investment preferences <a class="text-underline" [href]="getFileUrlByName('investmentPreference')" target="_blank">click here.</a></p>
  </ng-template>
</div>
<div class="main-container">
  <div class="investment-preferences-choice" *ngIf="!preferencesUpdated">
    <div class="radio-toolbar">
      <mat-button-toggle-group [(ngModel)]="preferencesSettingOption" (change)="onPreferencesSettingOptionChange()">
        <mat-button-toggle [value]="true">Yes, Set Preferences</mat-button-toggle>
        <mat-button-toggle [value]="false">No, I'll do this later</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
  <div class="investment-preferences-container" *ngIf="preferencesUpdated && activeFinzyVersion === 'FINZY_V1'">
    <mat-accordion>
      <mat-expansion-panel class="mb-3 accordion-panel-main" (afterExpand)="afterExpand('finzyPro')" (afterCollapse)="afterCollapse()" >
      <mat-expansion-panel-header class="accordion-expansion-panel-header">
        <div class="investment-preferences-category-header">
          <div class="category-heading">finzyPro+ Master Rating Preference</div>
        </div>
        <div class="category-description" [ngClass]="{'category-description-ellipsis': accordionExpansion.finzyPro === false}">
          Choose your preferred loan rating categories below. This master preference will be the default selection used to find loans for your portfolios.
          You can also customise this at an individual portfolio level later. You can find more information about allocation of your investment to loans
          <a (click)="onKnowMoreAboutFinzyProMasterPreferencesClicked()" class="align-self-end">here</a>
        </div>
        <div [ngClass]="{'d-lg-none': accordionExpansion.finzyPro === true}">
          <div class="investment-preferences-current-header">Selected Preference</div>
          <ul class="investment-preferences-current-selected">
            <li *ngFor="let bucket of selectedPreferencesBucket" class="font-weight-bold col-sm-2">{{ bucket }}</li>
          </ul>
        </div>
      </mat-expansion-panel-header>
      <div class="accordion-collapsible-panel">
        <div class="investment-preferences-customization-container mt-3 p-4">
          <div class="investment-preferences-customization-header">Customise your rating preference</div>
          <div class="investment-preferences-customization-option">
            <app-rating-selector
                    [preferredCategories]="preferredCategories"
                    (preferredCategoriesChange)="onPreferredCategoriesChanged($event)"
                    forbiddenRatingsAlertType="error">
            </app-rating-selector>
          </div>
        </div>
      </div>
      
    </mat-expansion-panel>
    <mat-expansion-panel class="mb-3 accordion-panel-main" (afterExpand)="afterExpand('reinvest')" (afterCollapse)="afterCollapse()" >
      <mat-expansion-panel-header class="accordion-expansion-panel-header">
        <div class="investment-preferences-category-header">
          <div class="category-heading">ReinvestPRO</div>
        </div>
        <div class="category-description" [ngClass]="{'category-description-ellipsis': accordionExpansion.reinvest === false}">
          Select the reinvestment preferences below to allot and reinvest all or part of the EMIs and
          prepayments that you receive, into new loans on the platform. Read more about how this works in our
          <a href="/faq?selectedTab=reinvest" target="_blank" rel="noopener noreferrer">FAQs section.</a>
        </div>
        <div [ngClass]="{'d-lg-none': accordionExpansion.reinvest === true}">
          <div class="investment-preferences-current-header">Selected Preference</div>
          <ul class="investment-preferences-current-selected">
            <li class="text-left">
              <span class="selected-preference-type">Reinvest Principal:</span>
              <span class="font-weight-bold" *ngIf="preferences?.reinvest?.emi?.reinvestPrincipal else valueTurnedOffTemplate">ON</span>
            </li>
            <li class="text-left">
              <span class="selected-preference-type">Reinvest Interest:</span>
              <span class="font-weight-bold" *ngIf="preferences?.reinvest?.emi?.reinvestInterest else valueTurnedOffTemplate">ON</span>
            </li>
            <li class="text-left">
              <span class="selected-preference-type">Reinvest Prepayment:</span>
              <span class="font-weight-bold" *ngIf="preferences?.reinvest?.prepayment?.reinvestPrincipal else valueTurnedOffTemplate">ON</span>
            </li>
            <ng-template #valueTurnedOffTemplate>
              <span class="font-weight-bold">OFF</span>
            </ng-template>
          </ul>
        </div>
      </mat-expansion-panel-header>
      <div class="accordion-collapsible-panel">
        <div class="investment-preferences-customization-container mt-3 p-4">
          <div class="investment-preferences-customization-header">Reinvest my EMIs</div>
          <div class="investment-preferences-customization-option">
            <p class="description">Your monthly EMI contains Principal and Interest component. To reinvest your entire EMI
              please choose to reinvest both Principal and Interest component.</p>
            <div class="investment-preferences-customization-option-auto-invest-container row">
              <div class="investment-preferences-customization-option-auto-invest-type col-sm-6 col-xs-12">
                <div class="auto-invest-row">
                  <div class="auto-invest-label">Principal component</div>
                  <div class="auto-invest-toggle  pr-4">
                    <mat-slide-toggle [ngModel]="preferences?.reinvest?.emi?.reinvestPrincipal"
                                      aria-label="Reinvest Principal component of EMI"
                                      (change)="onReinvestEMIPrincipalPreferenceChange($event.checked)"
                                      color="primary">
                    </mat-slide-toggle>
                  </div>
                </div>
                <div class="auto-invest-row">
                  <p>Principal component from your EMIs will be sent back to your registered bank account.</p>
                </div>
              </div>
              <div class="investment-preferences-customization-option-auto-invest-type col-sm-6 col-xs-12">
                <div class="auto-invest-row">
                  <div class="auto-invest-label">Interest component</div>
                  <div class="auto-invest-toggle  pr-4">
                    <mat-slide-toggle [ngModel]="preferences?.reinvest?.emi?.reinvestInterest"
                                      aria-label="Reinvest Interest component of EMI"
                                      (change)="onReinvestEMIInterestPreferenceChange($event.checked)"
                                      color="primary">
                    </mat-slide-toggle>
                  </div>
                </div>
                <div class="auto-invest-row">
                  <p>Interest component from your EMIs will be sent back to your registered bank account.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="accordion-collapsible-panel">
        <div class="investment-preferences-customization-container mt-3 p-4">
          <div class="investment-preferences-customization-header">Reinvest my Prepayments</div>
          <div class="investment-preferences-customization-option">
            <p class="description">At times, the borrower may choose to pre-pay a part or the full amount of loan outstanding.
              You can choose to allot and reinvest such prepayments in new loans.</p>
            <div class="investment-preferences-customization-option-auto-invest-container row">
              <div class="investment-preferences-customization-option-auto-invest-type col-sm-6 col-xs-12">
                <div class="auto-invest-row">
                  <div class="auto-invest-label">Entire Prepayment</div>
                  <div class="auto-invest-toggle pr-4">
                    <mat-slide-toggle [ngModel]="preferences?.reinvest?.prepayment?.reinvestPrincipal"
                                      aria-label="Reinvest Principal & Interest component of prepayement"
                                      (change)="onReinvestPrepaymentPreferenceChange($event.checked)"
                                      color="primary">
                    </mat-slide-toggle>
                  </div>
                </div>
                <div class="auto-invest-row">
                  <p class="auto-invest-description">All the prepayments will be sent back to your registered bank account.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel [expanded]="finzyBoltNeedsAttention" class="mb-3 accordion-panel-main" (afterExpand)="afterExpand('finzyBolt')" (afterCollapse)="afterCollapse()" >
      <mat-expansion-panel-header class="accordion-expansion-panel-header">
        <div class="investment-preferences-category-header">
          <div class="category-heading">finzyBolt</div>
        </div>
        <div class="category-description" [ngClass]="{'category-description-ellipsis': accordionExpansion.finzyBolt === false}">
          finzyBolt allows you to automatically create portfolios from your wallet based on your Master Rating preference.
        </div>
        <div [ngClass]="{'d-lg-none': accordionExpansion.finzyBolt === true}">
          <div class="investment-preferences-current-header">Selected Preference</div>
          <ul class="investment-preferences-current-selected">
            <li class="text-left">
              <span class="selected-preference-type">Selected Preference:</span>
              <span class="font-weight-bold" *ngIf="preferences?.automaticInvestmentsFromWallet else valueTurnedOffTemplate">ON</span>
            </li>
            <ng-template #valueTurnedOffTemplate>
              <span class="font-weight-bold">OFF</span>
            </ng-template>
          </ul>
        </div>
      </mat-expansion-panel-header>
      <div class="accordion-collapsible-panel">
        <div class="investment-preferences-customization-container mt-3 p-4">
          <div class="investment-preferences-customization-option">
            <div class="investment-preferences-customization-option-auto-invest-container row">
              <div class="investment-preferences-customization-option-auto-invest-type col-sm-12 col-xs-12">
                <div class="auto-invest-row">
                  <div class="auto-invest-label">finzyBolt</div>
                  <div class="auto-invest-toggle">
                    <mat-slide-toggle [ngModel]="preferences?.automaticInvestmentsFromWallet"
                                    aria-label="finzyBolt preference"
                                      (change)="onAutomaticInvestmentsFromWalletPreferenceChange($event.checked)"
                                      color="primary">
                    </mat-slide-toggle>
                  </div>
                </div>
                <div class="auto-invest-row">
                  <p class="auto-invest-description" *ngIf="preferences?.automaticInvestmentsFromWallet">
                    finzyBolt is turned on. If you wish to transfer funds and create portfolios yourself,
                    then you can switch off this preference at any point.</p>
                  <p class="auto-invest-description" *ngIf="!preferences?.automaticInvestmentsFromWallet">
                    finzyBolt is turned off. Please note, by switching on finzyBolt,
                    the capability to create portfolios yourself will not be available.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="investment-preferences-customization-secondary-container mt-4 p-1" *ngIf="preferences?.automaticInvestmentsFromWallet">
          <div class="investment-preferences-consent-container">
           <p class="consent-text">
             <mat-checkbox [checked]="finzyBoltConsentGranted" #consentChange class="consent-checkbox" (change)="onConsentChange($event)"></mat-checkbox>
             <span class="wrap-mat-radio-label">I, hereby confirm that I have not invested more than ₹50,00,000 across all the P2P platforms in India, including
               <a href="/" target="_blank" rel="noopener noreferrer">www.finzy.com</a>,
               in accordance with the <a href="/terms" target="_blank" rel="noopener noreferrer">Terms and conditions.</a>
               I, hereby also agree that as and when my investment across all the P2P platforms in India including
               <a href="/" target="_blank" rel="noopener noreferrer">www.finzy.com</a> exceed ₹10,00,000,
               I will provide finzy a net-worth certificate from a practicing Chartered Accountant in the
               <a [href]="getFileUrlByName('investorNetworthCertificate')" target="_blank" rel="noopener noreferrer">attached format</a>
               certifying that I have net-worth of more than ₹50,00,000.
               </span>
            </p>
          </div>
          <p class="text-error" *ngIf="consentChange.checked && !preferences?.automaticInvestmentsFromWallet">Please turn on finzyBolt first</p>
          <p class="text-error" *ngIf="preferences?.automaticInvestmentsFromWallet && !consentChange.checked">Please check the "Terms & Conditions"</p>
        </div>
      </div>
    </mat-expansion-panel>
    </mat-accordion>
  </div>
<!-- - - - - - - - - - - - - - - - - - - - - - - - - - - Finzy Flex Swift starts - - - - - - - - - - - - - - - - - - - - - - - - - -  -->

  <div class="investment-preferences-container" *ngIf="preferencesUpdated && activeFinzyVersion === 'FINZY_V2'">
    <mat-accordion>
      <mat-expansion-panel class="mb-3 accordion-panel-main-v2" (afterExpand)="afterExpand('swift')"
        (afterCollapse)="afterCollapse('swift')">
        <mat-expansion-panel-header class="accordion-expansion-panel-header">
          <div class="investment-preferences-category-header">
            <div class="category-heading category-heading-v2">Swift</div>
          </div>
          <div class="category-description category-description-v2">
            Swift is a convenient investment option allowing you to automatically invest your wallet funds into loan(s) without any intervention from your end. Click here to
            <a href="faq?selectedTab=FINZY_FLEX&preferenceType=swift#swift" target="_blank" class="align-self-end text-underline">Know More</a>
          </div>
        <div class="error-msg" *ngIf="(fundAllocationPreferenceForm.get('fundAllocation').errors?.error == 'allocateFundFormValidatorError') && (swiftExpanded == false)">Looks like your setup is incomplete!</div>
        </mat-expansion-panel-header>
        <div class="accordion-collapsible-panel">
          <div class="investment-preferences-customization-container-v2 mt-3">
            <mat-accordion hideToggle>
              <form [formGroup]="fundAllocationPreferenceForm">
                <mat-expansion-panel class="mat-elevation-z0 expansion-panel-v2" [disabled]="true"
                  [expanded]="setPannel === 0">
                  <mat-expansion-panel-header (click)="setPannelHeader(0)" class="panel-header">
                    <input type="radio" class="radio-btn mr-3" color="primary" formControlName="swift" id="id1"
                      value="SWIFT" />
                    <label for="id1" class="panel-header-label">Enter the allocation</label>
                  </mat-expansion-panel-header>
                  <div class="accordion-collapsible-panel pannel-offset swift-margin">
                    <div class="row inputFieldContainer" formArrayName="fundAllocation">
                      <div class="col-3 product-wrap" *ngFor="let product of subProducts; let i=index">
                        <div class="input-box" [formGroupName]="i">
                          <label class="input-label">{{product.name}}</label>
                          <input class="input-field" (keypress)="isNumberKey($event)" (keyup)="onInputChanges($event)"
                            type="number" min="1" placeholder="Allocation in %" formControlName="attributeValue"
                            max="100" onKeyPress="if(this.value.length==3) return false;" />
                            <span *ngIf="fundAllocationPreferenceForm?.controls?.fundAllocation?.controls[i]?.controls?.attributeValue?.value" class="percent-symbol">%</span>
                        </div>
                        <div class="note">MHP <app-tooltip placement="bottom"><i class="infoIcon material-icons"
                              trigger>info_outline</i>
                            <div class="tooltip-max" content>Minimum Holding Period <strong class="bold-black">(MHP)</strong> is the period of months during which the <strong class="bold-black">finzyFLEX</strong> investments cannot be withdrawn to bank account.</div>
                          </app-tooltip><strong class="note-strong">&nbsp;&nbsp;{{product.mhp}} m</strong>
                        </div>
                        <div class="note">Interest:<strong class="note-strong">&nbsp;&nbsp;upto {{product.roi}}% p.a.</strong>
                        </div>
                      </div>
                    </div>
                    <div class="error-message-space" *ngIf="fundAllocationPreferenceForm.get('fundAllocation')?.invalid">
                      <div
                        *ngIf="fundAllocationPreferenceForm.get('fundAllocation').errors?.error == 'allocateFundFormValidatorError'">
                        <span class="error-text mt-3">Allocation must add upto 100% in one or multiple investment options</span>
                      </div>
                      <div
                        *ngIf="fundAllocationPreferenceForm.get('fundAllocation').errors?.error == 'negativeValueValidatorError'">
                        <span class="error-text mt-3">Allocation must not be negative</span>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel class="mat-elevation-z0 expansion-panel-v2" [disabled]="true"
                  [expanded]="setPannel === 1">
                  <mat-expansion-panel-header (click)="setPannelHeader(1)" class="panel-header">
                    <input type="radio" class="radio-btn mr-3" color="primary" formControlName="swift" id="id2"
                      value="setupLaterSwift" />
                    <label for="id2" class="panel-header-label">Set up Later</label>
                  </mat-expansion-panel-header>
                </mat-expansion-panel>
              </form>
            </mat-accordion>
          </div>
        </div>
      </mat-expansion-panel>
  
      <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - Finzy Flex nCash starts - - - - - - - - - - - - - - - - - - - - - - - - - -  -->
      <form [formGroup]="userAttributesForm">
        <mat-expansion-panel class="mb-3 accordion-panel-main-v2" (afterExpand)="afterExpand('nCash')"
          (afterCollapse)="afterCollapse('nCash')">
          <mat-expansion-panel-header class="accordion-expansion-panel-header">
            <div class="investment-preferences-category-header">
              <div class="category-heading category-heading-v2">nCash</div>
            </div>
            <div class="category-description category-description-v2">
              nCash provides you an option to withdraw a fixed or a customized amount periodically from your investments. Click here to 
              <a href="faq?selectedTab=FINZY_FLEX&preferenceType=nCash" target="_blank" class="align-self-end text-underline">Know More</a>
            </div>
            <div class="error-msg" *ngIf="(userAttributesForm.controls.frequency.invalid || userAttributesForm.controls.date.invalid) && (nCashExpanded == false)">Looks like your setup is incomplete!</div>
          </mat-expansion-panel-header>
          <div class="accordion-collapsible-panel">
            <div class="investment-preferences-customization-container-v2 mt-3">
              <mat-accordion hideToggle>
                  <mat-expansion-panel class="mat-elevation-z0 expansion-panel-v2" [disabled]="true"
                    [expanded]="setPannel === 2">
                    <mat-expansion-panel-header (click)="setPannelHeader(2)" class="panel-header">
                      <input type="radio" class="radio-btn mr-3" color="primary" value="MAX_LIMIT" id="id3"
                        formControlName="nCash" />
                      <label for="id3" class="panel-header-label">Max nCash</label>
                    </mat-expansion-panel-header>
                    <div class="accordion-collapsible-panel pannel-offset">
                      <div class="investment-preferences-customization-container-v2">
                        <div class="investment-preferences-customization-header">Select Frequency</div>
                        <div class="investment-preferences-current-selected-container">
                          <div class="col" *ngFor="let frequency of frequencies; let i=index">
                            <input type="radio" [id]="i+1" [value]="frequency.value" formControlName="frequency">
                            <label class="frequency-button" [for]="i+1">{{frequency.key}}</label>
                          </div>
                        </div>
                        <span class="error-text" *ngIf="userAttributesForm.controls.frequency.invalid">Please select your nCash frequency
                        </span>
                        <div class="investment-preferences-customization-header" style="margin-top:15px;">Select Date</div>
                        <div class="investment-preferences-current-selected-container">
                          <div class="col" *ngFor="let date of dates; let i=index">
                            <input type="radio" [id]="i+5" [value]="date.value" formControlName="date">
                            <label class="frequency-button" [for]="i+5">{{date.key}}<sup>th</sup> of Month</label>
                          </div>
                        </div>
                        <span class="error-text" *ngIf="userAttributesForm.controls.date.invalid">Please select your nCash date
                        </span>
                        <div class="investment-preferences-current-selected-note mt-4">
                          <div class="notes">Note:&nbsp;&nbsp;You can set <strong class="notes-strong">Custom nCash
                              amount</strong> post finzyFLEX investments
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                  <mat-expansion-panel class="mat-elevation-z0 expansion-panel-v2" [disabled]="true"
                    [expanded]="setPannel === 3">
                    <mat-expansion-panel-header (click)="setPannelHeader(3)" class="panel-header">
                      <input type="radio" class="radio-btn mr-3" color="primary" value="INTEREST_ONLY" id="id4"
                        formControlName="nCash" />
                      <label for="id4" class="panel-header-label"> Interest Only</label>
                    </mat-expansion-panel-header>
                    <div class="accordion-collapsible-panel pannel-offset">
                      <div class="investment-preferences-customization-container-v2">
                        <div class="investment-preferences-customization-header">Select Frequency</div>
                        <div class="investment-preferences-current-selected-container">
                          <div class="col" *ngFor="let frequency of frequencies; let i=index">
                            <input type="radio" [id]="i+8" [value]="frequency.value" formControlName="frequency">
                            <label class="frequency-button" [for]="i+8">{{frequency.key}}</label>
                          </div>
                        </div>
                        <span class="error-text" *ngIf="userAttributesForm.controls.frequency.invalid">Please select your nCash frequency
                        </span>
                        <div class="investment-preferences-customization-header" style="margin-top:15px;">Select Date</div>
                        <div class="investment-preferences-current-selected-container">
                          <div class="col" *ngFor="let date of dates; let i=index">
                            <input type="radio" [id]="i+12" [value]="date.value" formControlName="date">
                            <label class="frequency-button" [for]="i+12">{{date.key}}<sup>th</sup> of Month</label>
                          </div>
                        </div>
                        <span class="error-text" *ngIf="userAttributesForm.controls.date.invalid">Please select your nCash date
                        </span>
                        <div class="investment-preferences-current-selected-note mt-4">
                          <div class="notes">Note:&nbsp;&nbsp;You can set <strong class="notes-strong">Custom nCash
                              amount</strong>
                            post finzyFLEX investments</div>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                  <mat-expansion-panel class="mat-elevation-z0 expansion-panel-v2" [disabled]="true"
                    [expanded]="setPannel === 4">
                    <mat-expansion-panel-header (click)="setPannelHeader(4)" class="panel-header">
                      <input type="radio" class="radio-btn mr-3" color="primary" value="setupLaterNCash" id="id5"
                        formControlName="nCash" />
                      <label for="id5" class="panel-header-label"> Set Up Later</label>
                    </mat-expansion-panel-header>
                  </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
        </mat-expansion-panel>

      <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - Finzy Flex Loan Preference starts - - - - - - - - - - - - - - - - - - - - - - - - - -  -->
  
        <mat-expansion-panel class="mb-3 accordion-panel-main-v2" (afterExpand)="afterExpand('loanPreference')"
          (afterCollapse)="afterCollapse('loanPreference')">
          <mat-expansion-panel-header class="accordion-expansion-panel-header">
            <div class="investment-preferences-category-header">
              <div class="category-heading category-heading-v2">Loan Preferences</div>
            </div>
            <div class="category-description category-description-v2">
              You can choose your preferred loan rating categories below. 
              This master FLEX Loan preference will be used to find loans for any Swift, Auto and Pro reinvestment into Flex portfolios that are created. 
              Your customization will be applied to portfolios that are created after you save your preference here.
            </div>
            <div class="error-msg" *ngIf="(userAttributesForm.controls.frequency.invalid || userAttributesForm.controls.date.invalid) && (loanPreference == false)">Looks like your setup is incomplete!</div>
          </mat-expansion-panel-header>
          <div *ngIf="showFormPreferenceForm" formGroupName="loanPreference" class="accordion-collapsible-panel">
            <div class="investment-preferences-customization-container-v2 mt-3">
              <div class="my-3 pannel-header padding-25px border-radius-6px">
                <div class="sub-heading">
                    <p class="font-bold text-left m-0">Maximum Loan Amount</p>
                </div>
                <div class="sub-heading-discription">
                    Maximum loan amount you want to invest in one loan
                </div>
                <div class="mt-2">
                    <mat-button-toggle-group 
                      name="maxLoanAmount" 
                      aria-label="loanAmountMax"
                      class="border-0"
                      [value]="maxLoanAmountToggle"
                      (change)="maxLoanAmountChange($event)">
                        <div class="mb-1">
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                <mat-button-toggle class="rounded-1 common-button px-0"
                                    value="1">1% of portfolio amount</mat-button-toggle>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                <mat-button-toggle class="rounded-1  common-button px-0"
                                    value="2">2% of portfolio amount</mat-button-toggle>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                <mat-button-toggle class="rounded-1  common-button px-0"
                                    value="5">5% of portfolio amount</mat-button-toggle>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-3 p-0">
                                <mat-button-toggle class="rounded-1  common-button px-0"
                                    value="10">10% of portfolio amount</mat-button-toggle>
                            </div>
                        </div>
                    </mat-button-toggle-group>
                </div>
              </div>

              <div class="my-3 pannel-header padding-25px border-radius-6px">
                <div class="sub-heading">
                    <p class="font-bold text-left m-0">Loan Tenure Preference</p>
                </div>
                <div class="sub-heading-discription">Select the loan tenure you want to invest in</div>
                <div class="mt-2">
                    <mat-button-toggle-group 
                      name="tenurePreference" 
                      aria-label="tenurePreference"
                      class="border-0" 
                      [value]="tenurePreferenceToggle"
                      (change)="preferredTenureChange($event)">
                        <div class="mb-1">
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                <mat-button-toggle class="rounded-1 common-button px-0"
                                    value="12">Less than 12 months</mat-button-toggle>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                <mat-button-toggle class="rounded-1  common-button px-0"
                                    value="24">Less than 24 months</mat-button-toggle>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                                <mat-button-toggle class="rounded-1  common-button px-0"
                                    value="36">Less than 36 months</mat-button-toggle>
                            </div>
                        </div>
                    </mat-button-toggle-group>
                </div>
              </div>

              <div class="my-3 pannel-header padding-25px border-radius-6px">
                <div class="sub-heading">
                    <p class="font-bold text-left m-0">Interest Rate & Risk Range</p>
                </div>
                <div class="sub-heading-discription">You can choose the minimum 2 interest rates and risk range from below</div>
                <div class="mt-2">
                    <mat-button-toggle-group 
                        name="interestRate" 
                        aria-label="interestRateAndRiskRangeChange"
                        class="border-0" 
                        [value]="interestRateRiskRangeToggle"
                        (change)="interestRateChange($event, true)" 
                        multiple>
                        <div>
                          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                            <mat-button-toggle class="d-flex flex-column py-3 border w-100"
                                style="border-radius: 5px;" value="A1-A6">
                                <p style="line-height: normal;" class="mb-0">Low Risk (A1-A6)</p>
                                <small class="d-block button-subheading" style="line-height: normal;">10.99% to 15.99%</small>
                            </mat-button-toggle>
                          </div>

                          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                              <mat-button-toggle class="d-flex flex-column py-3 border w-100"
                                  style="border-radius: 5px;" value="B1-B6">
                                  <p style="line-height: normal;" class="mb-0">Medium Risk (B1-B6)</p>
                                  <small class="d-block button-subheading" style="line-height: normal;">16.99% to 21.99%</small>
                              </mat-button-toggle>
                          </div>

                          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mt-3 p-0 pr-2">
                              <mat-button-toggle class="d-flex flex-column py-3 border w-100"
                                  style="border-radius: 5px;" value="C1-C6">
                                  <p style="line-height: normal;" class="mb-0">High Risk (C1-C6)</p>
                                  <small class="d-block button-subheading" style="line-height: normal;">22.99% to 27.99%</small>
                              </mat-button-toggle>
                          </div>
                        </div>
                    </mat-button-toggle-group>
                </div>
                <div *ngIf="userAttributesForm.get('loanPreference.interestRateRiskRange').status === 'INVALID'">
                  <span class="error-text">Please select minimum two interest rate & risk range</span>
                </div>
                <div class="expected-return-section my-3">
                  <div class="sub-heading">
                    <p class="font-bold text-left m-0">
                      Expected Return
                      <span class="text-muted font-weight-normal"
                        >(per annum)</span
                      >
                    </p>
                  </div>
                  <div class="sub-heading-discription">
                    Expected return calculated based on your Interest Rate & Risk
                    Range selection
                  </div>
                  <div class="row mt-3 mx-0">
                    <ng-container *ngIf="riskScore">
                      <div class="col-xs-6 col-sm-6 col-md-3 col-12 p-0 pr-2 mt-2" *ngFor="let item of getProductFromRiskScore()">
                        <button class="w-100 rounded-1 common-button d-flex justify-content-between align-items-center height-50px p-1 pl-4">
                          <span>{{item}}</span>
                          <div class="expected-return-roi-bg">
                            <ng-container *ngIf="userAttributesForm.get('loanPreference.expectedReturn.'+ item).value === 0; else showPercentageValue">
                              <mat-icon>minimize</mat-icon>
                          </ng-container>
                            <ng-template #showPercentageValue class="text-success font-bold">
                              <span class="text-success font-bold">
                                {{userAttributesForm.get('loanPreference.expectedReturn.'+ item).value}}%
                              </span>
                            </ng-template>
                          </div>
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </form>
    </mat-accordion>
  </div>
</div>

<!-- - - - - - - - - - - - - - - - - - - - - - - - - - - Form Submit starts - - - - - - - - - - - - - - - - - - - - - - - - - -  -->

<div class="row pb-5 button-wrapper">
  <div class="col-xs-6 back-btn">
    <button mat-stroked-button class="button-back primary" type="button" (click)="previous()">
      <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
    </button>
  </div>
  <div class="col-xs-6" *ngIf="!this.step.changed && activeFinzyVersion === 'FINZY_V1'">
    <div class="pull-right">
      <app-forward-button class="button-forward" (click)="next('Skip')">
        SKIP THIS STEP
      </app-forward-button>
    </div>
  </div>
  <div class="col-xs-6" *ngIf="this.step.changed && activeFinzyVersion === 'FINZY_V1'">
    <div class="pull-right">
      <app-forward-button class="button-forward" [disabled]="!step.isComplete"
                          [isLoading]="loaderStatus.isLoading" (click)="savePreferences()">NEXT</app-forward-button>
    </div>
  </div>




  <div 
    class="col-xs-6 skip-btn" 
    *ngIf="fundAllocationPreferenceForm.controls.swift.value === 'setupLaterSwift' &&
    userAttributesForm.controls.nCash.value === 'setupLaterNCash' && 
    activeFinzyVersion === 'FINZY_V2'  && 
    !loanPreferenceExpanded &&
    !isEdited">
    <div class="pull-right">
      <app-forward-button class="button-forward" (click)="next('Skip')">
        SKIP FOR NOW
      </app-forward-button>
    </div>
  </div>


  <div class="col-xs-6 skip-btn" 
    *ngIf="(
      fundAllocationPreferenceForm.controls.swift.value === 'SWIFT' ||
      userAttributesForm.controls.nCash.value === 'MAX_LIMIT' ||
      userAttributesForm.controls.nCash.value === 'INTEREST_ONLY' ||
      userAttributesForm.controls.loanPreference.value === 'MAX_LIMIT' ||
      loanPreferenceExpanded ||
      isEdited) &&
      activeFinzyVersion === 'FINZY_V2'">
    <div class="pull-right">
      <div *ngIf="dataLoader === true" class="loader">
        <mat-spinner [diameter]="35"></mat-spinner>
        </div>
      <app-forward-button
      type="button"
      class="button-forward"
      [disabled]="userAttributesForm.invalid || fundAllocationPreferenceForm.invalid"
      [class.disabled]="userAttributesForm.invalid || fundAllocationPreferenceForm.invalid"
      *ngIf="dataLoader === false"
      (click)="onSubmitForm()">
      SAVE AND CONTINUE
    </app-forward-button>
    </div>
  </div>
</div>
